import { useState } from 'react'
import { appStyles } from './app.style'
import { ContainerApp, ContentApp, FooterApp, HeaderApp, LabelApp } from './Layout.app'
import { regexOnlyNumbersUpTo8 } from '../helpers/validations.helper'
import toast from 'react-hot-toast'
import { api } from '../data/api'
import { useNavigate } from 'react-router-dom'
import { ButtonInApp } from './ButtonInApp.component'
import { AxiosError } from 'axios'

const errorStyles = {
	color: 'red',
	fontSize: '0.875rem',
	marginTop: '0.5rem',
}

export const ChangePassApp = () => {
	const navigate = useNavigate()

	const [formData, setFormData] = useState<{
		oldpass: string
		newpass: string
		passconf: string
	}>({
		oldpass: '',
		newpass: '',
		passconf: ''
	})

	const [errors, setErrors] = useState<Record<string, string>>({})

	const handleInputChange = (field: string, value: string) => {
		setFormData({...formData, [field]: value})

		if (errors[field]) {
			setErrors({...errors, [field]: ''})
		}
	}

	const handleInputBlur = (field: string, value: string) => {
		// const input = document.querySelector(`[name="${field}"]`) as HTMLInputElement;
		// if (!input) return;

		// let customMessage = '';

		// switch (field) {
		// 	case 'oldpass':
		// 		if (!value || value.length < 4 || !value.match(regexOnlyNumbersUpTo8) ) customMessage = 'El pin debe tener 4 dígitos numéricos';
		// 		break;
		// 	case 'newpass':
		// 		if (!value || value.length < 4 || !value.match(regexOnlyNumbersUpTo8) ) customMessage = 'El pin debe tener 4 dígitos numéricos';
		// 		break;
		// 	case 'passconf':
		// 		if (!value || value.length < 4 || !value.match(regexOnlyNumbersUpTo8) ) customMessage = 'El pin debe tener 4 dígitos numéricos';
		// 		else if (value !== formData.newpass) customMessage = 'Los pins deben coincidir';
		// 		break;
				
		// }
		// input.setCustomValidity(customMessage);
	}

	const validateForm = () => {
		const newErrors = {} as any
		if (!formData.oldpass) newErrors.oldpass = 'El pin actual es obligatorio'
		else if (!formData.oldpass.match(regexOnlyNumbersUpTo8)) newErrors.oldpass = 'El pin actual debe tener 4 dígitos numéricos'
		else if (formData.oldpass.length != 4) newErrors.oldpass = 'El pin actual debe tener 4 dígitos numéricos'

		if (!formData.newpass) newErrors.newpass = 'El nuevo pin es obligatorio'
		else if (!formData.newpass.match(regexOnlyNumbersUpTo8)) newErrors.newpass = 'El nuevo pin debe tener 4 dígitos numéricos'
		else if (formData.newpass.length != 4) newErrors.newpass = 'El nuevo pin debe tener 4 dígitos numéricos'
		
		if (!formData.passconf) newErrors.passconf = 'La confirmación de pin es obligatoria'
		else if (!formData.passconf.match(regexOnlyNumbersUpTo8)) newErrors.passconf = 'La confirmación de pin debe tener 4 dígitos numéricos'
		else if (formData.passconf.length != 4) newErrors.passconf = 'La confirmación de pin debe tener 4 dígitos numéricos'
		
		if (formData.newpass !== formData.passconf) newErrors.passconf = 'Los pins deben coincidir'

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleSubmit = async () => {
		if (!validateForm()) return;
		try {
			await api.post('/api/authp/change-pin', formData);
			toast.success('Contraseña cambiada correctamente');
			navigate('/app/menu');
		} catch (error) {
			console.error("### error", error);
			toast.error(error instanceof AxiosError ? error.response?.data?.message :'Error cambiando la contraseña');
		}
	}

	return (
		<ContainerApp>
			<HeaderApp title="Cambiar Pin" />
			<ContentApp>
				<LabelApp label="Pin Actual" />
				<input
					type="password"
					name="oldpass"
					placeholder="PIN de 4 dígitos"
					style={appStyles.input}
					maxLength={4}
					minLength={4}
					value={formData.oldpass}
					onChange={(e) => handleInputChange('oldpass', e.target.value)}
					onBlur={(e) => handleInputBlur('oldpass', e.target.value)}
					required
				/>
				{errors.oldpass && <p style={errorStyles}>{errors.oldpass}</p>}
				<LabelApp label="Nuevo Pin" />
				<input
					type="password"
					name="newpass"
					placeholder="PIN de 4 dígitos"
					style={appStyles.input}
					maxLength={4}
					minLength={4}
					value={formData.newpass}
					onChange={(e) => handleInputChange('newpass', e.target.value)}
					onBlur={(e) => handleInputBlur('newpass', e.target.value)}
					required
				/>
				{errors.newpass && <p style={errorStyles}>{errors.newpass}</p>}
				<LabelApp label="Confirmar el Pin" />
				<input
					type="password"
					name="passconf"
					placeholder="PIN de 4 dígitos"
					style={appStyles.input}
					maxLength={4}
					minLength={4}
					value={formData.passconf}
					onChange={(e) => handleInputChange('passconf', e.target.value)}
					onBlur={(e) => handleInputBlur('passconf', e.target.value)}
					required
				/>
				{errors.passconf && <p style={errorStyles}>{errors.passconf}</p>}
			</ContentApp>
			<FooterApp>
				<ButtonInApp 
					label="Atrás"
					type="button"
					onClick={() => navigate('/app/menu')}
				/>
				<ButtonInApp 
					label="Cambiar"
					type="button"
					onClick={() => handleSubmit()}
					disabled={!formData.oldpass || !formData.newpass || !formData.passconf}
				/>
			</FooterApp>
		</ContainerApp>
	)
}